/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type SettingsPageContractViewFragment = { invoiceCustomerName: string, email: string, paymentMethod: Types.PaymentMethod, isEditablePeriod: boolean, contractType: Types.ContractType };

export const SettingsPageContractViewFragmentDoc = gql`
    fragment SettingsPageContractView on Contract {
  invoiceCustomerName
  email
  paymentMethod
  isEditablePeriod
  contractType
}
    `;